module.exports = __webpack_public_path__ + "img/52_chess.0122f180.jpg";